// @flow

// State Configuration
export const TREE = 'assetData'
export const BRANCH = 'assets'
